"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderContactInfoSection = renderContactInfoSection;
var _litHtml = require("lit-html");
require("solid-ui/components/actions/button");
var _ContactInfoEditDialog = require("./ContactInfoEditDialog");
var _solidUi = require("solid-ui");
require("./ContactInfoSection.css");
var _texts = require("../../texts");
var _collapsibleSection = require("../shared/collapsibleSection");
var _phoneCountries = require("../shared/phoneCountries");
var _contactTypeUtils = require("../shared/contactTypeUtils");
var _profileIcons = require("../../icons-svg/profileIcons");
var _contactIcons = require("../../icons-svg/contactIcons");
function toText(value) {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object' && 'value' in value) {
    const v = value.value;
    return typeof v === 'string' ? v : '';
  }
  return '';
}
function normalizeContactValue(rawValue, kind) {
  if (!rawValue) return '';
  if (kind === 'email') {
    return rawValue.replace(/^mailto:/i, '');
  }
  const normalizedPhone = rawValue.replace(/^tel:/i, '');
  const {
    localNumber
  } = (0, _phoneCountries.splitPhoneValue)(normalizedPhone);
  return localNumber || normalizedPhone;
}
function resolveContactValue(store, point, kind) {
  if (!point) return '';
  const directValue = toText(point.valueNode || point.entryNode).trim();
  const looksLikeExpectedValue = kind === 'email' ? /^mailto:/i.test(directValue) || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(directValue) : /^tel:/i.test(directValue) || /^[+()\-\s\d]{5,}$/.test(directValue);
  if (looksLikeExpectedValue) {
    return normalizeContactValue(directValue, kind);
  }
  const entryNode = point.entryNode || point.valueNode;
  if (entryNode) {
    const storedValueNode = store.any(entryNode, _solidUi.ns.vcard('value'));
    const storedValue = toText(storedValueNode).trim();
    if (storedValue) return normalizeContactValue(storedValue, kind);
  }
  return normalizeContactValue(directValue, kind);
}
function renderPhone(phone, store) {
  if (!phone) return (0, _litHtml.html)``;
  const phoneValue = resolveContactValue(store, phone, 'phone');
  const phoneType = (0, _contactTypeUtils.normalizePhoneTypeForEdit)(phone.type);
  return (0, _litHtml.html)`<li class="contact-info__item" role="listitem">
        <div class="contact-info__icon-wrapper">
          <span class="contact-info__icon" aria-hidden="true">${_contactIcons.phoneIcon}</span>
        </div>
        <div class="contact-info__item-body">
          <span class="contact-info__contact-point-value">${phoneValue}</span>
          ${phoneType ? (0, _litHtml.html)`<span class="contact-info__contact-point-type"> ${phoneType}</span>` : (0, _litHtml.html)``}
        </div>
      </li>`;
}
function renderPhones(phones, store) {
  if (!phones || !phones.length || !phones[0]) return (0, _litHtml.html)``;
  return (0, _litHtml.html)`${renderPhone(phones[0], store)}${phones.length > 1 ? renderPhones(phones.slice(1), store) : (0, _litHtml.html)``}`;
}
function renderEmail(email, store) {
  if (!email) return (0, _litHtml.html)``;
  const emailValue = resolveContactValue(store, email, 'email');
  const emailType = (0, _contactTypeUtils.normalizeEmailTypeForEdit)(email.type);
  return (0, _litHtml.html)`<li class="contact-info__item" role="listitem">
        <div class="contact-info__icon-wrapper">
          <span class="contact-info__icon" aria-hidden="true">${_contactIcons.emailIcon}</span>
        </div>
        <div class="contact-info__item-body">
          <span class="contact-info__contact-point-value">${emailValue}</span>
          ${emailType ? (0, _litHtml.html)`<span class="contact-info__contact-point-type">${emailType}</span>` : (0, _litHtml.html)``}
        </div>
      </li>`;
}
function renderEmails(emails, store) {
  if (!emails || !emails.length || !emails[0]) return (0, _litHtml.html)``;
  return (0, _litHtml.html)`${renderEmail(emails[0], store)}${emails.length > 1 ? renderEmails(emails.slice(1), store) : (0, _litHtml.html)``}`;
}
function renderAddress(address) {
  if (!address) return (0, _litHtml.html)``;
  const streetAddress = toText(address.streetAddress || address.fullAddress).trim();
  const locality = toText(address.locality).trim();
  const region = toText(address.region).trim();
  const postalCode = toText(address.postalCode).trim();
  const countryName = toText(address.countryName).trim();
  const localityRegion = [locality, region].filter(Boolean).join(', ');
  const localityRegionPostal = [localityRegion, postalCode].filter(Boolean).join(' ');
  return (0, _litHtml.html)`
        <li class="contact-info__item" role="listitem">
          <div class="contact-info__icon-wrapper">
            <span class="contact-info__icon" aria-hidden="true">${_profileIcons.locationIcon}</span>
          </div>
          <span class="contact-info__address">
            ${streetAddress ? (0, _litHtml.html)`${streetAddress}<br />` : (0, _litHtml.html)``}
            ${localityRegionPostal ? (0, _litHtml.html)`${localityRegionPostal}<br />` : (0, _litHtml.html)``}
            ${countryName}
          </span>
        </li>`;
}
function renderAddresses(addresses) {
  if (!addresses || !addresses.length || !addresses[0]) return (0, _litHtml.html)``;
  return (0, _litHtml.html)`${renderAddress(addresses[0])}${addresses.length > 1 ? renderAddresses(addresses.slice(1)) : (0, _litHtml.html)``}`;
}
function renderContactInfoSectionDefault(store, subject, contactInfo, viewerMode, onSaved) {
  const hasAnyContactInfo = contactInfo?.emails.length > 0 || contactInfo?.phones.length > 0 || contactInfo?.addresses.length > 0;
  const isOwner = viewerMode === 'owner';
  return (0, _litHtml.html)`
    <section
      aria-labelledby="contact-details-heading"
      data-profile-section="contact-info"
      class="profile__section profile-section-collapsible profile-section-collapsible--inline-mobile-actions"
      role="region"
      tabindex="-1"
      data-expanded="false"
    >
      <header class="profile__section-header profile-section-collapsible__header">
        <h3 id="contact-details-heading" tabindex="-1">${_texts.contactInfoHeadingText}</h3>
        <div class="profile-section-collapsible__actions">
          ${isOwner ? (0, _litHtml.html)`
            <solid-ui-button
              type="button"
              variant="secondary"
              size="sm"
              class="profile__action-button profile-action-text profile-section-collapsible__edit-button"
              aria-label="Edit contact information"
              @click=${event => {
    return (0, _ContactInfoEditDialog.createContactInfoEditDialog)(event, store, subject, contactInfo, viewerMode, onSaved);
  }}
            >
              <span class="profile-section-collapsible__edit-label profile__add-more-content">
                <span class="profile__add-more-icon" aria-hidden="true">${_profileIcons.addIcon}</span>
                <span>Add More</span>
              </span>
              <span class="profile-section-collapsible__edit-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
            </solid-ui-button>
          ` : (0, _litHtml.html)``}
          <solid-ui-button
            type="button"
            variant="icon"
            size="sm"
            class="profile-section-collapsible__toggle-button"
            aria-label="Toggle contact information section"
            aria-controls="contact-details-panel"
            aria-expanded="false"
            @click=${_collapsibleSection.toggleCollapsibleSection}
          >
            <span slot="icon" class="profile-section-collapsible__chevron" aria-hidden="true">${_profileIcons.chevronDownIcon}</span>
          </solid-ui-button>
        </div>
      </header>
      <div id="contact-details-panel" class="profile-section-collapsible__content">
        ${contactInfo.phones.length > 0 ? (0, _litHtml.html)`
              <ul class="contact-info__list" role="list" aria-label="Phone numbers">
                ${renderPhones(contactInfo.phones, store)}
              </ul>
            ` : (0, _litHtml.html)``}
        ${contactInfo.emails.length > 0 ? (0, _litHtml.html)`
              <ul class="contact-info__list" role="list" aria-label="Email addresses">
                ${renderEmails(contactInfo.emails, store)}
              </ul>
            ` : (0, _litHtml.html)``}
        ${contactInfo.addresses.length > 0 ? (0, _litHtml.html)`
              <ul class="contact-info__list" role="list" aria-label="Postal addresses">
                ${renderAddresses(contactInfo.addresses)}
              </ul>
            ` : (0, _litHtml.html)``}
        ${hasAnyContactInfo ? (0, _litHtml.html)`` : (0, _litHtml.html)`<p>No contact details added yet.</p>`}
      </div>
    </section>
  `;
}
function renderOwnerEmptyContactInfoContent(_store, _subject, _contactInfo, _viewerMode, _onSaved) {
  return (0, _litHtml.html)`
      <div class="profile__empty-state-content" role="group" aria-label="Empty contact information section">    
        <div class="contact-info__empty-icon-wrapper">
          <span class="contact-info__empty-icon">${_profileIcons.envelopeIcon}</span>
        </div>
        <p class="profile__empty-state-message contact-info__empty-message">
            No additional contact info added yet.
        </p>
      </div>
  `;
}
function renderOwnerEmptyContactInfoSection(store, subject, contactInfo, viewerMode, onSaved) {
  return (0, _litHtml.html)`
    <section 
      aria-labelledby="contact-details-heading" 
      data-profile-section="contact-info"
      class="profile__section--empty profile__section--empty-sidebar profile-section-collapsible profile-section-collapsible--inline-mobile-actions" 
      role="region"
      tabindex="-1"
      data-expanded="false"
    >
      <header class="profile__section-header profile-section-collapsible__header">
        <h3 id="contact-details-heading" tabindex="-1">${_texts.contactInfoEmptyHeadingText}</h3>
        <div class="profile-section-collapsible__actions">
          <solid-ui-button
            type="button"
            variant="secondary"
            size="sm"
            class="profile__action-button profile-action-text profile-section-collapsible__edit-button"
            aria-label="Add contact information"
            @click=${event => {
    return (0, _ContactInfoEditDialog.createContactInfoEditDialog)(event, store, subject, contactInfo, viewerMode, onSaved);
  }}
          >
            <span class="profile-section-collapsible__edit-label">${_profileIcons.addIcon} Add More</span>
            <span class="profile-section-collapsible__edit-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
          </solid-ui-button>
          <solid-ui-button
            type="button"
            variant="icon"
            size="sm"
            class="profile-section-collapsible__toggle-button"
            aria-label="Toggle contact information section"
            aria-controls="contact-details-panel"
            aria-expanded="false"
            @click=${_collapsibleSection.toggleCollapsibleSection}
          >
            <span slot="icon" class="profile-section-collapsible__chevron" aria-hidden="true">${_profileIcons.chevronDownIcon}</span>
          </solid-ui-button>
        </div>
      </header>
      <div id="contact-details-panel" class="profile-section-collapsible__content">
        ${renderOwnerEmptyContactInfoContent(store, subject, contactInfo, viewerMode, onSaved)}
      </div>
    </section>
  `;
}
function renderContactInfoSection(store, subject, contactInfo, viewerMode, onSaved) {
  const safeContactInfo = {
    emails: contactInfo?.emails || [],
    phones: contactInfo?.phones || [],
    addresses: contactInfo?.addresses || []
  };
  const hasAnyContactInfo = safeContactInfo.emails.length > 0 || safeContactInfo.phones.length > 0 || safeContactInfo.addresses.length > 0;
  const showOwnerEmptyContactInfo = !hasAnyContactInfo && viewerMode === 'owner';
  const showSection = true;
  return showSection ? (0, _litHtml.html)`
    ${showOwnerEmptyContactInfo ? renderOwnerEmptyContactInfoSection(store, subject, safeContactInfo, viewerMode, onSaved) : renderContactInfoSectionDefault(store, subject, safeContactInfo, viewerMode, onSaved)}
  ` : '';
}